
const guestPass = {
  namespaced: true,
  state: {
    params: {
      id: '',
      departDate:'',
      flightNo:'',
      bz:'',
    },
    flightInfo: {},
    searchInfo: {},
    travelerList: [],
    detail:[]
  },
  getters: {//getters属性理解为所有组件的computed属性, 也就是计算属性 
    searchInfo: (state) => {
      return state.searchInfo || {}
    },
    params: (state) => {
      return state.params || {}
    },
    flightInfo: (state) => {
      return state.flightInfo || {}
    },
    travelerList: (state) => {
      return state.travelerList || []
    },
    detail: (state) => {
      return state.detail || []
    }
  },
  mutations: { //mutaions理解为store中的methods
    searchInfo (state, payload) {
      Object.assign(state.searchInfo,payload)
    },
    params (state, payload) {
      Object.assign(state.params,payload)
    },
    flightInfo (state, payload) {
      state.flightInfo=payload
    },
    travelerList (state, payload) {
      state.travelerList = payload
    },
    setDetail (state, payload) {
      state.detail = payload
    },
    CLEAR_ALL (state, payload) { 
      state.carSearchInfo = {}
      state.travelerList=[]
      state.detail=[]
    }
  },
  actions: { //添加actions actions中可以包含异步操作
    // minusPriceAsync( context, payload ) {
    // setTimeout( () => {
    //     context.commit( 'minusPrice', payload ); //context提交
    // }, 2000)
    // }
  }
}
export default guestPass